module.exports = __webpack_public_path__ + "media/images/message-07dc2b85868631535d7a6e95298c20a2.svg";